export const PARTY_KIND = {
  PERSON: 'Person',
  PLACE: 'Place',
};

export const PARTY_KIND_OPTIONS = [{ Code: PARTY_KIND.PERSON }, { Code: PARTY_KIND.PLACE }];

export const PARTY_KIND_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Code',
  showLabelOnly: true,
};
